import selectFolder from '../actions/selectFolder';
import { FOLDER_CLICKED } from 'mini-mail-workflow-tracking/lib/constants/ListViewWorkflowConstants';
import { getFolderNameCustomData } from 'mini-mail-list-store/lib/selectors/getFolderNameCustomData';
import { logUsage } from 'owa-analytics';
import { signalWorkflowEvent } from 'mini-workflow-manager';

/**
 * Triggered when user explicitly selects a folder
 * @param folderId id of the folder selected by the user
 */
export const selectFolderIntentional = (folderId: string) => {
    const folderNameCustomData = getFolderNameCustomData(folderId);
    signalWorkflowEvent(FOLDER_CLICKED, folderNameCustomData);
    logUsage('SelectFolder', folderNameCustomData, { isCore: true });
    selectFolder(folderId);
};
